export const money = value => Number(value || 0).toLocaleString('vi-VN', { maximumFractionDigits: 0 }) + ' đ';

export const lifecycleStatus = status => ({
    PENDING: { color: 'default', label: 'Chờ xử lý' },
    RECONCILED: { color: 'blue', label: 'Đã đối soát' },
    APPROVED: { color: 'green', label: 'Đã duyệt' },
    RETURN_FOR_CORRECTION: { color: 'orange', label: 'Trả về chỉnh sửa' },
    REJECT_FINAL: { color: 'red', label: 'Không duyệt' },
    REJECTED: { color: 'red', label: 'Đã từ chối' },
    OPEN: { color: 'processing', label: 'Đang mở' },
    LOCKED: { color: 'success', label: 'Đã chốt kỳ' },
    DRAFT: { color: 'default', label: 'Chờ chi trả' },
    PARTIAL: { color: 'warning', label: 'Đã chi trả một phần' },
    PAID: { color: 'success', label: 'Đã chi trả đủ' },
    FAILED: { color: 'error', label: 'Thất bại' },
    RETURNED: { color: 'warning', label: 'Đã hoàn trả' },
    REVERSED: { color: 'warning', label: 'Đã thu hồi giao dịch' },
    ACTIVE: { color: 'success', label: 'Đang áp dụng' },
    CANCELLED: { color: 'default', label: 'Đã hủy' },
    FINAL: { color: 'green', label: 'Đã chốt tổng hợp' },
    STALE: { color: 'orange', label: 'Cần tổng hợp lại' },
}[status] || { color: 'default', label: status || 'Chưa xác định' });
